import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import retreatSlice from './slices/retreatSlice';
import destinationSlice from './slices/destinationSlice';
import retreatTypeSlice from './slices/retreatTypeSlice';
import blogSlice from './slices/blogSlice';
import offerSlice from './slices/offerSlice';
import uiSlice from './slices/uiSlice';
import partnerSlice from './slices/partnerSlice';
import mediaSlice from './slices/mediaSlice';
import countrySlice from './slices/countrySlice';
import userSlice from './slices/userSlice';
import createRetreatSlice from './slices/createRetreatSlice';
import teacherSlice from './slices/teacherSlice';
import organizerSlice from './slices/organizerSlice';
import centerSlice from './slices/centerSlice';
import retreatStyleSlice from './slices/retreatStyleSlice';
import skillLevelSlice from './slices/skillLevelSlice';
import ageSlice from './slices/ageSlice';
import atmosphereSlice from './slices/atmosphereSlice';
import benefitSlice from './slices/benefitSlice';
import serviceSlice from './slices/serviceSlice';
import bookingSlice from './slices/bookingSlice';
import userBookingsSlice from './slices/userBookingsSlice';
import adminBookingsSlice from './slices/adminBookingsSlice';
import paymentWebhookSlice from './slices/paymentWebhookSlice';
import paymentSlice from './slices/paymentSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    retreats: retreatSlice,
    destinations: destinationSlice,
    retreatTypes: retreatTypeSlice,
    blog: blogSlice,
    offers: offerSlice,
    ui: uiSlice,
    partner: partnerSlice,
    media: mediaSlice,
    country: countrySlice,
    user: userSlice,
    createRetreat: createRetreatSlice,
    teachers: teacherSlice,
    organizers: organizerSlice,
    centers: centerSlice,
    retreatStyles: retreatStyleSlice,
    skillLevels: skillLevelSlice,
    ages: ageSlice,
    atmospheres: atmosphereSlice,
    benefits: benefitSlice,
    services: serviceSlice,
    booking: bookingSlice,
    userBookings: userBookingsSlice,
    adminBookings: adminBookingsSlice,
    paymentWebhook: paymentWebhookSlice,
    payments: paymentSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
